export const method = 'post';

export default {
    message: 'Successfully logged out',
};